import React, { FC, ReactElement } from 'react'
import { BaseBranding, ListBranding } from '../Types'
// eslint-disable-next-line import/no-cycle
import { BrandingFormEntry } from './BrandingFormEntry'
import { NameSpacing } from '../../../NonReact/utils/NameSpacing'
import {
    ArrayField,
    useFieldArray,
    UseFieldArrayMethods,
    useFormContext,
    UseFormMethods
} from '../../../Vendor/react-hook-form/dist/index.ie11'
import { IconName } from '../../Common/Components/Icon'
import IconButton, { IconButtonType } from '../../Common/Components/IconButton'
import { getBrandingFieldName } from '../FieldName'
import { EMPTY_STRING } from '../../../NonReact/constants/Common'

type Props = {
    parentFieldNameFunction: (fieldName: string) => string
    listBranding: ListBranding
    viewOnly: boolean
}

export const BrandingExpandableList: FC<Props> = ({
    parentFieldNameFunction,
    listBranding,
    viewOnly
}: Props): ReactElement => {
    const { fieldName, subEntries }: ListBranding = listBranding

    const { control }: UseFormMethods = useFormContext()
    const { append, remove, fields }: UseFieldArrayMethods = useFieldArray({
        control,
        name: getBrandingFieldName(parentFieldNameFunction(fieldName))
    })

    return (
        <div className='branding-expandable-list'>
            {fields?.map(
                (entry: Partial<ArrayField>, index: number): ReactElement => (
                    <div key={entry.id} className='branding-list-elements'>
                        <div className='ble-sub-entry-container'>
                            {subEntries?.map(
                                (brandingConfig: BaseBranding): ReactElement => (
                                    <BrandingFormEntry
                                        key={`${fieldName}-${index}-${brandingConfig.fieldName}`}
                                        brandingData={brandingConfig}
                                        viewOnly={viewOnly}
                                        fieldNameFunction={(field: string): string =>
                                            parentFieldNameFunction(NameSpacing(`${fieldName}[${index}]`, field))
                                        }
                                    />
                                )
                            )}
                        </div>
                        <IconButton
                            type={IconButtonType.BUTTON}
                            iconName={IconName.REMOVE}
                            onClick={(): void => remove(index)}
                        />
                    </div>
                )
            )}
            <IconButton
                customClassName='bel-add-button'
                iconName={IconName.ADD}
                type={IconButtonType.BUTTON}
                onClick={(): void =>
                    append({
                        icon: EMPTY_STRING,
                        label: EMPTY_STRING,
                        url: EMPTY_STRING
                    })
                }
            />
        </div>
    )
}
